import { render, staticRenderFns } from "./addTask.vue?vue&type=template&id=13aaf1cb&scoped=true&"
import script from "./addTask.vue?vue&type=script&lang=tsx&"
export * from "./addTask.vue?vue&type=script&lang=tsx&"
import style0 from "./addTask.vue?vue&type=style&index=0&id=13aaf1cb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13aaf1cb",
  null
  
)

export default component.exports